var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00005 14.0001C1 13.9355 1 13.8689 1 13.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40973 1.71547 1.71547 1.40973 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4801 1 17.9079 1.21799C18.2842 1.40973 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.07899 19 4.19691V13.8031C19 14.2881 19 14.6679 18.9822 14.9774M1.00005 14.0001C1.00082 14.9884 1.01337 15.5058 1.21799 15.9074C1.40973 16.2837 1.71547 16.5905 2.0918 16.7822C2.5192 17 3.07899 17 4.19691 17H15.8036C16.9215 17 17.4805 17 17.9079 16.7822C18.2842 16.5905 18.5905 16.2837 18.7822 15.9074C18.9055 15.6654 18.959 15.3813 18.9822 14.9774M1.00005 14.0001L5.76798 8.4375L5.76939 8.43596C6.19227 7.9426 6.40406 7.69551 6.65527 7.60645C6.87594 7.52821 7.11686 7.53004 7.33643 7.61133C7.58664 7.70397 7.79506 7.95387 8.21191 8.4541L10.8831 11.6595C11.269 12.1226 11.463 12.3554 11.6986 12.4489C11.9065 12.5313 12.1357 12.5406 12.3501 12.4773C12.5942 12.4053 12.8091 12.1904 13.2388 11.7607L13.7358 11.2637C14.1733 10.8262 14.3921 10.6076 14.6397 10.5361C14.8571 10.4734 15.0896 10.4869 15.2988 10.5732C15.537 10.6716 15.7302 10.9124 16.1167 11.3955L18.9822 14.9774M18.9822 14.9774L19 14.9996M13 7C12.4477 7 12 6.55228 12 6C12 5.44772 12.4477 5 13 5C13.5523 5 14 5.44772 14 6C14 6.55228 13.5523 7 13 7Z",
    stroke: "#0c3255",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.d2ddda246d7617efb9d9cd36625cf722.svg";
export { ForwardRef as ReactComponent };